import * as React from "react";
import { IconProps } from "../types";

const CircleExclamationFillIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="12"
        height="13"
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M6 0.5C2.691 0.5 0 3.191 0 6.5C0 9.809 2.691 12.5 6 12.5C9.309 12.5 12 9.809 12 6.5C12 3.191 9.309 0.5 6 0.5ZM5.25 4C5.25 3.586 5.586 3.25 6 3.25C6.414 3.25 6.75 3.586 6.75 4V7C6.75 7.414 6.414 7.75 6 7.75C5.586 7.75 5.25 7.414 5.25 7V4ZM6 10.25C5.518 10.25 5.125 9.857 5.125 9.375C5.125 8.893 5.518 8.5 6 8.5C6.482 8.5 6.875 8.893 6.875 9.375C6.875 9.857 6.482 10.25 6 10.25Z"
          fill={color}
        />
      </svg>
    );
  },
);

export default CircleExclamationFillIcon;
